import { useQuery } from "@tanstack/react-query";
import { isAllBusiness } from "@/api";
import { demoInactiveFoodicsAccounts } from "@/demo";
import { isDefined } from "@norma-bi/utils";
import { useRootAPI } from "@/api";

export function useGetInactiveFoodicsAccounts(
  args: Partial<{
    businessId: string;
    enabled: boolean;
    userIsDemo?: boolean;
  }>,
) {
  const { businessId, enabled = true, userIsDemo = false } = args;
  const rootAPI = useRootAPI();

  return useQuery({
    queryKey: ["accounts", businessId, userIsDemo],
    queryFn: async () => {
      if (userIsDemo) {
        return demoInactiveFoodicsAccounts;
      }
      return rootAPI.getInactiveUsersByBusiness({ business_id: businessId! }).then((r) => r.data);
    },
    enabled: enabled && ((isDefined(businessId) && !isAllBusiness(businessId)) || userIsDemo),
  });
}
